var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "paid-mobile-wrap" }, [
    _c("div", { staticClass: "mb-close", on: { click: _vm.closeDetail } }),
    _vm._v(" "),
    _c("div", {
      staticClass: "mb-title",
      domProps: { innerHTML: _vm._s(_vm.versionText.title) }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "line-left" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("USER_ACCOUNT") + _vm.getConstants("COLON")
              ) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "line-right line-right-user",
          domProps: { innerHTML: _vm._s(_vm.userInfo.userName) }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "line-left" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("PRICING_NEW_DETAIL_CURRENT_VERSION") +
                  _vm.getConstants("COLON")
              ) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "line-right line-version" }, [
          _c("span", { staticClass: "version" }, [
            _vm._v(_vm._s(_vm.userInfo.version))
          ]),
          _vm._v(" "),
          _vm.isPaidUser
            ? _c("i", { class: _vm.isUserExpired ? "is-user-expired" : "" }, [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm.getConstants("PRICING_MOBILE_DETAIL_EXPRIED") +
                        " " +
                        _vm.userInfo.expireDate
                    ) +
                    ")"
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "line-left" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("PRICING_NEW_DETAIL_TOTAL_STORAGE") +
                  _vm.getConstants("COLON")
              ) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "line-right" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(_vm.userInfo.storage) +
              _vm._s(
                _vm.PageInfo.storageQuota &&
                  " (" +
                    _vm.getConstants("PRICING_NEW_DETAIL_CURRENT_STORAGE") +
                    _vm.getConstants("COLON") +
                    _vm.PageInfo.storageQuota +
                    ")"
              ) +
              "\n\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "line-left" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("PRICING_NEW_DETAIL_EXPRIED") +
                  _vm.getConstants("COLON")
              ) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "line-right" }, [
          _vm._v(_vm._s(_vm.userInfo.expireDateAfterPay))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "line-left" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("PRICING_NEW_COMMON_EAGLE_PLAN") +
                  _vm.getConstants("COLON")
              ) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "line-right" }, [
          _vm._v(
            "\n\t\t\t\t" + _vm._s(_vm.versionText.planVersion) + "\n\t\t\t"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "line" }, [
        _c("div", { staticClass: "line-left", staticStyle: { opacity: "0" } }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("PRICING_NEW_COMMON_EAGLE_PLAN") +
                  _vm.getConstants("COLON")
              ) +
              "\n\t\t\t"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "line-right" }, [
          _vm._v(_vm._s(_vm.paidModal.content))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-buy" }, [
      _c("div", { staticClass: "mb-price" }, [
        _vm._v("¥ " + _vm._s(_vm.price.toFixed(2)))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mb-origin" }, [
        _c("p", { staticClass: "mb-origin-money" }, [
          _vm._v(_vm._s(_vm.versionText.originPrice))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "mb-origin-limit" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.getConstants("PRICING_NEW_EAGLE_SELECT_ORIGIN_SPECIAL")
              ) +
              "\n\t\t\t"
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-paid" },
      [
        _vm.isPaidInvalid
          ? _c(
              "e-button",
              { staticClass: "not-allowed", attrs: { type: "primary" } },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.getConstants("PRICING_NEW_DETAIL_NOT_ALLOW")) +
                    "\n\t\t"
                )
              ]
            )
          : _c(
              "e-button",
              { attrs: { type: "primary" }, on: { click: _vm.pay } },
              [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.getConstants("PRICING_MOBILE_PAY")) +
                    "\n\t\t"
                )
              ]
            )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-tips" }, [_vm._v(_vm._s(_vm.paidModal.tip))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }